import { Component, Input, OnInit } from '@angular/core';
import { OPERATORS } from '../services/constants';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Optional } from '@angular/core'

@Component({
  selector: 'app-custom-tooltip',
  templateUrl: './custom-tooltip.component.html',
  styleUrls: ['./custom-tooltip.component.scss']
})
export class CustomTooltipComponent implements OnInit {
  @Input() metadata: any;
  @Input() product: any;
  @Input() operator: any;
  @Input() refreshDataType: any;
  operators: any;

  constructor(@Optional() private dialogRef: MatDialogRef<CustomTooltipComponent>) {
    this.operators = OPERATORS;
   }

  ngOnInit(): void {
  }

  getObjectEntries(obj: any): any[] {
    if (obj != null)
    return Object.entries(obj);
    else return [];
  }

  formatKey(key: string): string {
    return key.replace(/_/g, ' ').replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
  }

  getPixelData(obj: any) {
    const flattenedBands: any = [];

    if (obj != null) {
      for (const band of obj[9].bandInfo) {
        const bandSetName = band.name;
        const bandSetData = band.bandset?.[0]; // assuming bandset is an array with one object
        if (!bandSetData) continue;

        for (const window in bandSetData) {
          if (window === 'length' || !Array.isArray(bandSetData[window])) continue;

          for (const bandDetail of bandSetData[window]) {
            flattenedBands.push({
              bandSet: bandSetName,
              window: window,
              name: bandDetail.name,
              wavelength: bandDetail.wavelength
            });
          }
        }
      }
    }

    return flattenedBands;
  }

  get metadataItems(): string[] {
    const md = this.metadata;
    if (typeof md === 'string') {
      if (md.includes(';')) {
        return md.split(';').map(i => i.trim());
      } else {
        return [md.trim()];
      }
    }
    return [];
  }
  closeplanUpgrade() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

}
